import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center select-none font-semibold transition-colors focus:outline-hidden focus:ring-2 text-center whitespace-nowrap focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        solid: "bg-accent-8 text-white",
        subtle: "bg-accent-3/80 text-accent-11",
        outline: "text-accent-9 border-accent-6 border",
        muted: "border-transparent bg-muted  hover:bg-muted/80",
        dot: "relative pl-5! before:absolute before:left-2 before:w-1.5 before:h-1.5 before:rounded-full before:bg-accent-8 bg-gray-3",
      },
      highContrast: {
        true: "",
      },
      glow: {
        true: "glow-sm-accent-800/20 dark:glow-sm-accent-500/20 border-accent-500 border",
      },
      depth: {
        true: "shadow-sm dark:shadow-none dark:highlight-white/20",
      },
      bordered: {
        true: "border border-accent-6",
        false: "border-0",
      },

      shadow: {
        true: "shadow-md shadow-accent-3 dark:shadow-none",
        false: "shadow-none",
      },

      size: {
        "2xs": "text-2xs px-1 py-px",
        xs: "text-2xs px-1.5 py-px",
        sm: "text-xs px-2 py-0.5",
        md: "text-sm px-3 py-1",
        lg: "text-sm px-4 py-1.5",
        xl: "text-base px-6 py-2",
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        full: "rounded-full",
      },
    },
    compoundVariants: [
      {
        variant: "solid",
        highContrast: true,
        class: "text-accent-contrast",
      },
    ],
    defaultVariants: {
      variant: "solid",
      size: "md",
      highContrast: false,
      radius: "md",
    },
  }
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
